import { render, staticRenderFns } from "./delete-case-pool.vue?vue&type=template&id=5df228e4&scoped=true"
import script from "./delete-case-pool.vue?vue&type=script&lang=ts"
export * from "./delete-case-pool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df228e4",
  null
  
)

export default component.exports